export default __webpack_public_path__ + "d0be2e75470e83da834ffe26ceb5e98a.png";